/**
 * src/shell/ui/components/SandboxFrame.tsx — 成品游戏沙箱（设计稿 S8 / 引擎 §8.5）。
 *
 * 形态铁律：iframe sandbox="allow-scripts"（禁 same-origin——AI 生成代码
 * 读不到父页面 localStorage / API Key）+ srcdoc 注入。
 * 产物来源：引擎产物区 readArtifact(projectId, 'index-html')；
 * 镇店预置游戏（assets 只读搬运）回退到 public/preset-games/<id>/index.html。
 */

import { useEffect, useState } from 'react'
import { readArtifact } from '../../../gm'
import { COPY } from '../../copy'

interface Props {
  projectId: string
  title: string
  height?: number | string
}

export function SandboxFrame({ projectId, title, height = 420 }: Props) {
  const [html, setHtml] = useState<string | null>(null)
  const [missing, setMissing] = useState(false)

  useEffect(() => {
    let cancelled = false
    setHtml(null)
    setMissing(false)
    const fromStore = readArtifact(projectId, 'index-html')
    if (fromStore?.trim()) {
      setHtml(fromStore)
      return
    }
    // 镇店预置游戏回退（只读搬运资产，原样引用）
    fetch(`${import.meta.env.BASE_URL}preset-games/${projectId}/index.html`)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((text) => {
        if (!cancelled) setHtml(text)
      })
      .catch(() => {
        if (!cancelled) setMissing(true)
      })
    return () => {
      cancelled = true
    }
  }, [projectId])

  if (missing) {
    return <div className="graybox graybox-warn">{COPY.sandbox.missing}</div>
  }
  if (html === null) {
    return <div className="graybox">{COPY.sandbox.loading}</div>
  }
  return (
    <iframe
      className="sandbox-frame"
      style={{ height }}
      title={title}
      sandbox="allow-scripts"
      srcDoc={html}
    />
  )
}
